export const variants = {
  h1: {
    fontSize: '56px',
    fontWeight: 700,
    lineHeight: '67px',
  },
  h2: {
    fontSize: '40px',
    fontWeight: 700,
    lineHeight: '52px',
  },
  h3: {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '42px',
  },
  h4: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '34px',
  },
  h5: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px',
  },
  h6: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '25px',
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
  subtitle2: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '21px',
  },
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '26px',
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
  },
  body3: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  label1: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  label2: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '17px',
  },
  label3: {
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '14px',
  },
  table: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
  },
};
